'use client';

import { TabText, TabTextItem } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { track } from '@musinsa/packages-event-snowplow';
import { parseAsString, useQueryState } from '@musinsa/packages-nuqs';
import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';
import { SNOWPLOW_SCHEME } from '../../snowplow';
import { isMusinsaService } from '../utils/campaignProposalMusinsaAnalytics';
import {
  trackSeedingListCategoryFilterClickAmplitude,
  trackSeedingListCategoryFilterClickMusinsa,
} from '../utils/seedingMusinsaAnalytics';

export const CAMPAIGN_CATEGORY_QUERY_KEY = 'category';

export const useCampaignCategory = () =>
  useQueryState(
    CAMPAIGN_CATEGORY_QUERY_KEY,
    parseAsString.withDefault('').withOptions({ history: 'replace' }),
  );

export const CampaignCategoryChips = () => {
  const [category, setCategory] = useCampaignCategory();
  const { service } = useDeviceInfo();
  const { data } = useQuery(curatorQueries.campaigns.recruitmentCategories());
  const categories = data?.categories ?? [];
  // curatorId — 29CM Snowplow layout_id 슬롯. react-query dedupe 로 추가 네트워크 없음.
  const { data: userInfo } = useQuery({ ...curatorQueries.profile.userInfo });
  const curatorId = userInfo?.snsTitle ?? '';

  // 시딩 캠페인 리스트 > 카테고리 필터 클릭 (GTM + Amplitude 무신사 dual-fire)
  const handleCategoryClick = (filterName: string, next: string | null) => {
    if (isMusinsaService(service)) {
      trackSeedingListCategoryFilterClickMusinsa({ filterName });
      trackSeedingListCategoryFilterClickAmplitude({ filterName });
    } else if (service === SERVICE['29CM']) {
      track({
        schema: SNOWPLOW_SCHEME.CLICK_BUTTON,
        data: {
          page_name: 'curator_seeding_campaign_list',
          section_name: 'CuratorCatogoryFilter',
          section_title: 'CuratorCatogoryFilter',
          button_id: 'curator_seeding_catogory_filter',
          button_name: filterName,
          position: -1,
          layout_id: curatorId,
        },
      });
    }
    setCategory(next);
  };

  return (
    <TabText colorScheme="gray" depth="oneDepth" divider="on">
      <TabTextItem
        key="all"
        isSelected={category === ''}
        disabledUnderline={false}
        onClick={() => handleCategoryClick('전체', null)}
      >
        전체
      </TabTextItem>
      {categories.map(({ categoryNo, categoryName }) => (
        <TabTextItem
          key={categoryNo}
          isSelected={category === categoryNo}
          disabledUnderline={false}
          onClick={() => handleCategoryClick(categoryName, categoryNo)}
        >
          {categoryName}
        </TabTextItem>
      ))}
    </TabText>
  );
};
